import React, { useEffect, useRef, useState } from 'react';

function AnimatedCounter({ from = 0, to = 0, duration = 1200, formatter }) {
  const [value, setValue] = useState(from);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startedRef.current) {
          startedRef.current = true;
          const startTime = performance.now();

          const animate = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            // easeOutCubic
            const eased = 1 - Math.pow(1 - progress, 3);
            const next = Math.round(from + (to - from) * eased);
            setValue(next);
            if (progress < 1) requestAnimationFrame(animate);
          };

          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [from, to, duration]);

  const display = formatter ? formatter(value) : value.toLocaleString();

  return (
    <span ref={ref}>{display}</span>
  );
}

export default AnimatedCounter;
